module.exports = __webpack_public_path__ + "img/cancelOrder.4bdce730.png";